import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiRadio, FiArrowRight } = FiIcons;

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, id) => {
    if (location.pathname === '/') {
      const el = document.getElementById(id);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <nav className={`fixed w-full z-[100] transition-all duration-300 ${isScrolled ? 'py-4 bg-black/90 backdrop-blur-md border-b border-white/10' : 'py-6 bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-10 h-10 bg-[#DFFF00] flex items-center justify-center rounded-sm group-hover:scale-110 transition-transform">
            <SafeIcon icon={FiRadio} className="text-black text-xl" />
          </div>
          <span className="text-2xl font-black tracking-tighter uppercase text-white">
            DUBTRACK<span className="text-[#DFFF00]">FM</span>
          </span>
        </Link>
        
        <div className="hidden md:flex items-center gap-10">
          <a 
            href="#solutions" 
            onClick={(e) => handleNavClick(e, 'solutions')}
            className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-400 hover:text-[#DFFF00] transition-colors"
          >
            Infrastructure
          </a>
          <a 
            href="#pricing" 
            onClick={(e) => handleNavClick(e, 'pricing')}
            className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-400 hover:text-[#DFFF00] transition-colors"
          >
            Deployment
          </a>
          <a 
            href="#contact"
            onClick={(e) => handleNavClick(e, 'contact')}
            className="bg-[#DFFF00] text-black px-6 py-3 text-[11px] font-black uppercase tracking-[0.2em] flex items-center gap-2 hover:bg-white transition-all shadow-[0_0_20px_rgba(223,255,0,0.2)]"
          >
            Get Started <SafeIcon icon={FiArrowRight} />
          </a>
        </div>
      </div>
    </nav>
  );
}